import React, { useEffect } from 'react';
import ParentComponent from '..';
import metaLogo from "../../../../assets/guardian.png";
import { Helmet } from "react-helmet";
import { useFlags } from 'launchdarkly-react-client-sdk';

const SessionOut = () => {
  const alertMainHeading = 'The connection has timed out';
  const alertInfoText =
    'We\'re sorry, this session was timed out by the server. Click the link you were provided via email to try again.';

  const sesionOutPropsData = {
    alertMainHeading,
    alertInfoText,
  };

  const { gaProducerTestFeatureFlag } = useFlags();
  

  useEffect(() => {
    document.title = 'Connection timed out | Guardian';
  }, [])

  return (
    <>
      <Helmet>
        <link rel="icon" type="image/png" href={metaLogo} />
      </Helmet>
      {gaProducerTestFeatureFlag ? (
        <div style={{ backgroundColor: 'green', padding: 8 }}>
          This block is visible because the feature flag is <strong>enabled.</strong>
        </div>
      ) : (
        <div style={{ backgroundColor: 'red', padding: 8 }}>
          This block is visible because the feature flag is <strong>disabled.</strong>
        </div>
      )}
      <ParentComponent propData={sesionOutPropsData} />
    </>
  );
};

export default SessionOut;